// ** Reason for utility: **
// absolute links
// images and paths to drupal
const richTextFilter = (data) => {
  
  if(data) {
    var filteredText = data

    // Check for links 
    // If an internal link (or absolute link to JMF site) make sure that we have a trailing slash
    if(filteredText.indexOf('</a>') > -1) {
      const regExpLiteral = /href=[\"\']([^\'\"]+)/g;
      let hrefArray = filteredText.match(regExpLiteral);

      if(hrefArray) {
        for (let i = 0; i < hrefArray.length; i++) {
          let href = hrefArray[i]
          let addTrailingSlash = true
          
          if(href.at(-1) === '/') {
            addTrailingSlash = false
          }
          else if(href.indexOf('.pdf') > 0) { // pdf file
            addTrailingSlash = false
          }
          else if(href.indexOf('mailto:') > 0) { // email
            addTrailingSlash = false
          }
          else if(href.indexOf('tel:') > 0) { // tel
            addTrailingSlash = false
          }
          else if(href.indexOf('http:') > 0 && href.indexOf('jmfinn.') < 0) { // external site link
            addTrailingSlash = false
          }
          else if(href.indexOf('?') > -1) { // query string
            addTrailingSlash = false
          }
          else if(href.indexOf('#') > -1) { // anchor string
            addTrailingSlash = false
          }
  
          if(addTrailingSlash) {
            let filteredTextUpdated = filteredText.replace(href, href+"/");
            filteredText = filteredTextUpdated
          }
        }
      }
    }

    return(filteredText)
  }
  else {
    return ('')
  }
}

export { richTextFilter }

